import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'getTimePointLimitAfterPosition' })
export class GetTimePointLimitAfterPositionPipe implements PipeTransform {
  transform(time: string, limit: number) {
    return moment(time, 'HH:mm:ss').add(limit, 'minutes').format('HH:mm');
  }
}
